// Is this key press somebody typing?
//
// Every accelerator on the game screen — the history transport's arrows, the
// camera's WASD — is a single letter with no modifier, which is also every
// character somebody types into the room code, the feedback box or the dev
// menu. **One helper, because two copies of this test drift**: the second one
// written is always the one that forgets `contentEditable`, and the symptom is
// a field that eats a letter and turns the board instead.

/** True while the event is aimed at something that takes typing. */
export function inField(event: KeyboardEvent): boolean {
  const target = event.target as HTMLElement | null;
  const tag = target?.tagName;
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    Boolean(target?.isContentEditable)
  );
}
